<template>
  <div class="PageCaresSummary">
    <Container>
      <div class="selector-wrap">
        <p class="selector-heading">期間</p>
        <SelectBox :value="dayRangeKey" @input="setDayRange" :items="dayRangeItems" />
      </div>
      <SectionCard title="身長">
        <template v-if="heightChartData">
          <p v-if="heightChartData.length === 0">データなし</p>
          <LineChart
            :chartData="heightChartData"
            :chartFrom="dataDayFrom"
            :chartTo="dataDayTo"
            valueUnit="cm"
          />
          <dl class="chokkin" v-if="lastChartData(heightChartData)">
            <dt>最終計測時（{{lastChartData(heightChartData).timestamp.format('YYYY/MM/DD')}}）</dt>
            <dd>{{lastChartData(heightChartData).value}}mm</dd>
          </dl>
        </template>
        <Loader v-else />
      </SectionCard>
      <SectionCard title="体重">
        <template v-if="weightChartData">
          <p v-if="weightChartData.length === 0">データなし</p>
          <LineChart
            :chartData="weightChartData"
            :chartFrom="dataDayFrom"
            :chartTo="dataDayTo"
            valueUnit="g"
          />
          <dl class="chokkin" v-if="lastChartData(weightChartData)">
            <dt>最終計測時（{{lastChartData(weightChartData).timestamp.format('YYYY/MM/DD')}}）</dt>
            <dd>{{lastChartData(weightChartData).value}}g</dd>
          </dl>
        </template>
        <Loader v-else />
      </SectionCard>
      <SectionCard title="体温">
        <template v-if="TemperatureChartData">
          <p v-if="TemperatureChartData.length === 0">データなし</p>
          <LineChart
            :chartData="TemperatureChartData"
            :chartFrom="dataDayFrom"
            :chartTo="dataDayTo"
            valueUnit="℃"
          />
          <dl class="chokkin" v-if="lastChartData(TemperatureChartData)">
            <dt>最終計測時（{{lastChartData(TemperatureChartData).timestamp.format('YYYY/MM/DD')}}）</dt>
            <dd>{{lastChartData(TemperatureChartData).value}}度</dd>
          </dl>
        </template>
        <Loader v-else />
      </SectionCard>
      <SectionCard title="授乳回数" v-if="false"><p>準備中</p></SectionCard>
      <SectionCard title="授乳間隔" v-if="false"><p>準備中</p></SectionCard>
    </Container>
  </div>
</template>

<script>
import Container from '@/components/atoms/Container'
import LineChart from '@/components/molecules/LineChart'
import Loader from '@/components/atoms/Loader'
import SelectBox from '@/components/atoms/SelectBox'
import SectionCard from '@/components/molecules/SectionCard'

import moment from 'moment'
import FirebaseCaresSummary from '@/firebase/caresSummary.ts'
const firebaseCaresSummary = new FirebaseCaresSummary()
const dataDayTo = moment().endOf('day')

export default {
  name: 'PageCaresSummary',
  layout: 'app',
  components: {
    Container,
    LineChart,
    Loader,
    SelectBox,
    SectionCard,
  },
  data() {
    return {
      heightChartData: null,
      weightChartData: null,
      TemperatureChartData: null,
      dataDayFrom: dataDayTo.clone().add(-2, 'days'),
      dataDayTo,
      dayRangeKey: '7-days',
      dayRangeItems: [
        {
          key: '7-days',
          label: '1週間'
        },
        {
          key: '1-months',
          label: '1ヶ月'
        },
        {
          key: '1-years',
          label: '1年'
        },
        {
          key: '2-years',
          label: '2年'
        },
      ]
    }
  },
  props: {
    child: {},
  },
  methods: {
    lastChartData(cd) {
      return cd && cd[cd.length - 1]
    },
    async refleshChartData() {
      await Promise.all([
        (async () => this.heightChartData = await firebaseCaresSummary.getSummaryHeight(this.child))(),
        (async () => this.weightChartData = await firebaseCaresSummary.getSummaryWeight(this.child))(),
        (async () => this.TemperatureChartData = await firebaseCaresSummary.getSummaryTemperature(this.child))(),
      ])
    },
    setDayRange(rangeKey) {
      this.dayRangeKey = rangeKey
      const [num, unit] = rangeKey.split('-')
      this.dataDayFrom = dataDayTo.clone().add(~~num * -1, unit)
    },
  },
  mounted() {
    this.refleshChartData()
  },
}
</script>

<style scoped lang="scss">
.selector-wrap {
  margin-bottom: 20px;
}
.selector-heading {
  margin-bottom: 5px;
  font-size: 12px;
  font-weight: bold;
}
.chokkin {
  display: flex;
  margin-top: 20px;
  padding: 7px 10px;
  border-radius: $round;
  background: $background;

  dt {
    flex: 1;
    font-size: 12px;
  }
  dd {
    font-weight: bold;
  }
}
</style>
